
function PageNotFound() {
  return (
    <><div></div><div className="div--error fade-in-up"><div className='div--error-sign'><img src="/kitty_sleepy.png" alt="No encontrado" width={150} height={150} /></div>404: Page not found...</div></>
  )
};

export default PageNotFound;